export default class {
  constructor() {
    this.instance = {
      emancipated: {
        introduction:
          "Para continuarmos sua auditoria, precisamos do envio do Certificado de Emancipação para o email <b>auditorias@qi.edu.br</b>. <br> Assim que for enviado, daremos prosseguimento ao processo.",
        itens: [
          {
            name: "Certificado de Emancipação",
            message: "<strong>Certifique-se de que ele esteja devidamente assinado e autenticado.</strong>",
            valid: null,
            visible: true,
            field: "doc-eman",
            editable: false
          },
        ]
      },

      dataStudent: {
        introduction:
          " Olá @PRIMEIRONOME_CLIENTE, tudo bem? " +
          " Falo em nome da QI Faculdade e Escola Técnica. Meu contato é referente à sua matrícula em nossa instituição, uma escolha tão significativa, e é um privilégio compartilhar este momento especial com você." +
          " Precisamos confirmar alguns dados para o envio do seu contrato, podemos dar seguimento?",
        itens: [
          {
            name: "Nome do Estudante",
            message: "O nome completo do aluno é <strong>@NOME_ALUNO</strong>?",
            valid: null,
            visible: true,
            field: "nome_aluno",
            editable: false
          },
          {
            name: "Naturalidade do Estudante",
            message: "Por favor, informe o estado e a cidade natal do aluno:",
            valid: null,
            visible: false,
            field: "naturalidade_aluno",
            editable: true
          },
          {
            name: "Endereço do Estudante",
            message:
              "Agora vamos confirmar o endereço, ok?",
            valid: null,
            visible: false,
            field: "endereco_aluno",
            editable: true
          },
          {
            name: "Data de Nascimento do Estudante",
            message:
              "A data de nascimento é <strong>@NASCIMENTO_ALUNO</strong>?",
            valid: null,
            visible: false,
            field: "nascimento-aluno",
            editable: false
          },
          {
            name: "Email do Estudante",
            message: "Agora uma confirmação muito importante! Qual o email do aluno?" +
              "<br>Através deste e-mail, ele receberá informações essenciais para a sua jornada em nossa instituição.",
            valid: null,
            visible: false,
            field: "email_aluno",
            editable: true
          },
          {
            name: "Grau de Escolaridade do Estudante",
            message: "Qual o grau de escolaridade do aluno?",
            valid: null,
            visible: false,
            field: "escolaridade_aluno",
            editable: true
          },
          {
            name: "Telefones do Estudante",
            message: "Precisamos confirmar os telefones do aluno, pois esse será o nosso principal canal de comunicação.",
            valid: null,
            visible: false,
            field: "telefones_aluno",
            editable: true
          },
          {
            name: "Documentos do Estudante",
            message: "O CPF do aluno é <strong>@CPF_ALUNO</strong>?",
            valid: null,
            visible: false,
            field: "documentos_aluno",
            editable: false
          },
          {
            name: "Filiação do Estudante",
            message: "Filiação:",
            valid: null,
            visible: false,
            field: "pai_mae",
            editable: true
          }
        ]
      },

      dataClient: {
        introduction:
          "Agora vamos confirmar os dados do responsável pelo contrato." +
          " Salientamos que o responsavel é unico autorizado a solicitar qualquer tipo de alteração deste contrato.",
        itens: [
          {
            name: "Nome do Responsável",
            message: "Seu nome completo é <strong>@NOME_CLIENTE</strong>?",
            valid: null,
            visible: true,
            field: "nome_cliente",
            editable: false
          },
          {
            name: "Data de Nascimento do Responsável",
            message:
              "A sua data de nascimento é <strong>@NASCIMENTO_CLIENTE</strong>?",
            valid: null,
            visible: false,
            field: "nascimento-cliente",
            editable: false
          },
          {
            name: "Email do Responsável",
            message: "Agora precisamos confirmar seu e-mail." +
              "<br> Lembrando que este é o único autorizado para validar alterações e realizar assinatura deste contrato.",
            valid: null,
            visible: false,
            field: "email_cliente",
            editable: true
          },
          {
            name: "Telefones do Responsável",
            message: "Seus telefones são:",
            valid: null,
            visible: false,
            field: "telefones_cliente",
            editable: true
          },
          {
            name: "Documentos do Responsável",
            message: "Seu CPF é <strong>@CPF_CLIENTE</strong>?",
            valid: null,
            visible: false,
            field: "documentos_cliente",
            editable: false
          },
          {
            name: "Endereço do Responsável",
            message: "Vamos confirmar o endereço, ok?",
            valid: null,
            visible: false,
            field: "endereco_cliente",
            editable: true
          }
        ]
      },

      academic: {
        introduction:
          "Obrigado(a) pelas informações, agora vamos realizar as confirmações sobre o curso, certo?",
        itens: [
          {
            name: "Curso",
            message:
              "O curso escolhido foi <strong>@NOMECURSO</strong>?",
            valid: null,
            field: "nome_curso",
            visible: true
          },
          {
            name: "Aproveitamentos",
            message:
              "<strong>ATENÇÃO!</strong><strong> Questionar o cliente e informar sobre o processo, mesmo que o contrato não possua aproveitamentos. </strong>" +
              "<br><br>Foi realizado algum aproveitamento de estudos na sua matrícula?" +
              "<br><br>O aproveitamento de estudos elimina do contrato disciplinas aprovadas em outras instituições ou cursos da própria QI, após analise da coordenação." +
              " As disciplinas aproveitadas e seus respectivos valores, não serão contabilizadas no contrato, alterando assim, o numero de disciplinas e o seu valor final. " +
              " Quanto a conclusão do curso, dependerá do nosso calendário de ofertas, podendo ou não ser antecipada a formação do aluno. ",
            valid: null,
            visible: false
          },
          {
            name: "Filial",
            message:
              "As aulas acontecerão na filial <strong>@CODFILIAL</strong>?" +
              "<br>No endereço <strong>@ENDERECOFILIAL</strong> ",
            valid: null,
            visible: false,
            field: "filial"
          },
          {
            name: "Boas Vindas",
            message:
              "A primeira disciplina será <strong>@BOASVINDAS</strong>, com data inicial em <strong>@DTINICIOBOASVINDAS</strong>, no dia da semana e horário: <strong>@HORARIOBOASVINDAS</strong>? <br><br>" +
              " Nesta aula introdutória, serão apresentadas informações importantes do curso e as ferramentas que serão utlizadas pelo aluno em sua jornada na QI.<br><br>" +
              " O aluno receberá um e-mail alguns dias antes, solicitando a confirmação de presença nesta aula. Reforço que é muito importante a participação.",
            valid: null,
            visible: false,
          },
          {
            name: "Disciplinas",
            message:
              "Após a aula de boas vindas, a primeira disciplina será <strong>@DISCIPLINA</strong>, com data de início para <strong>@DTINICIODISCIPLINA</strong>. " +
              "<br /><br />Verificar dias da semana e horários abaixo:",
            valid: null,
            field: "lista-disciplinas",
            visible: false
          },
          {
            name: "Forma de Ingresso",
            message:
              "A forma de ingresso no curso de graduação será <strong>@FORMAINGRESSO</strong>?",
            valid: null,
            modality: 3,
            visible: false
          },
          {
            name: "Particularidades do Curso",
            message: "@PARTICULARIDADES",
            valid: null,
            visible: false
          }
        ]
      },
      financial: {
        introduction:
          "Seguiremos agora com as confirmações financeiras.",
        itens: [
          {
            name: "Taxa de Matrícula",
            message:
              "Qual foi o valor pago na sua taxa de inscrição?" +
              "<br><br><strong>ATENÇÃO!<br>Valor apenas para fins de referência e não deve ser informado ao cliente!</strong>" +
              "<br>Valor da Taxa: R$ @VALORTAXA",
            valid: null,
            field: "valor_taxa",
            visible: true
          },
          {
            name: "Forma de Pagamento das Parcelas",
            message:
              "A forma de pagamento escolhida para o parcelamento do curso foi <strong>@FORMAPAGTOPARCELA</strong>, com desconto de <strong>@DESCADIMP%</strong> se pago até o vencimento?" +
              "<br><br>Esse desconto é válido apenas para esse meio de pagamento.",
            valid: null,
            field: "pag-parc",
            visible: false
          },
          {
            name: "Quantidade de Parcelas",
            message:
              "O parcelamento ficou em <strong>@NUMPARCELA</strong> parcela(s)?",
            valid: null,
            visible: false
          },

          {
            name: "Vencimento da Primeira Parcela",
            message:
              "O vencimento da primeira parcela ficou para <strong>@DTVENCIMENTOPARC</strong>?",
            valid: null,
            field: "venc-parc",
            visible: false
          },
          {
            name: "Vencimento da Segunda Parcela",
            message:
              "O vencimento da segunda parcela ficou para <strong>@DTVENCIMENTOPARC2</strong>?",
            valid: null,
            visible: false
          },
          {
            name: "Parcelamento",
            message:
              "Abaixo temos um quadro com a simulação das suas parcelas, vamos conferir o valor da bolsa, o desconto adimplência." +
              "<br><br>Reforço que o valor liquido informado, é válido apenas até a data de vencimento das parcelas." +
              "<br><br>Em seu contrato os valores estão informados no quadro financeiro, sem o desconto pontualidade, a referência estará abaixo em negrito com o percentual de desconto correspondente.",
            valid: null,
            field: "confere-finan",
            visible: false

          }
        ]
      },
      conclusion: {
        introduction:
          "Vamos para as últimas confirmações!",
        itens: [
          {
            name: "Documentação do Aluno",
            message:
              "Lembrando que a documentação obrigatória deve ser entregue em 7 dias após a nossa confirmação. " +
              "<br>Será enviado um e-mail com a lista  da documentação necessária, que poderão ser entregues direto na sua unidade ou ser enviados pelo e-mail que será informado.",
            valid: null,
            field: "doc-aluno",
            visible: true
          },
          {
            name: "Central de Vagas",
            message:
              "Foi lhe dito algo sobre nossa Central de Vagas?" +
              "<br><br><strong>Se sim: </strong> O que lhe foi dito sobre?" +
              " (Deixar o cliente falar, para que fique gravado na ligação)" +
              "<br>Explicar o que realmente é a Central de Vagas, deixando claro que não encaminhamos para emprego, é apenas um auxilio com a divulgação de vagas." +
              "<br><br><strong>Se não: </strong>Certo então. A QI oferece a Central de Vagas, um suporte para nossos estudantes que buscam se inserir no mercado de trabalho." +
              "<br>Trata-se de um grupo no WhatsApp, onde são divulgadas vagas disponíveis no mercado de trabalho, permitindo que nossos estudantes se candidatem às oportunidades de seu interesse." +
              "<br>Lembrando que a QI não encaminha, nem participa do processo seletivo.",
              valid: null,
              visible: false
          },
          {
            name: "Para finalizar, vou ler com você a cláusula 20 do contrato:",
            message:
              "20 - As partes declaram que o presente Contrato corresponde à manifestação final, completa e excluisva do acordo celebrado e substitui integralmente quaisquer acordos, propostas ou contratos firmados anteriormente com o mesmo objeto sejam verbais ou escritos.",
              valid: null,
              visible: false
          },
          {
            name: "Confirmação da Pré",
            message: "Aguarde enquanto realizo a confirmação da sua matrícula!",
            valid: null,
            visible: false,
            field: "confirmacao_pre",
          },
          {
            name: "Confirmação da Assinatura do Contrato",
            message:
              "Enviei o contrato para seu e-mail, pode me confirmar se recebeu? Peço que leia com atenção para então realizar a assinatura do contrato." +
              " Qualquer dúvida, você pode buscar o suporte da central de atendimento.",
            valid: null,
            field: "contrato",
            visible: false
          },
          {
            name: "Finalização",
            message:
              "Foi lhe prometido algo além do que conversamos agora?" +
              "<br>Ficou alguma dúvida?" +
              "<br><br></nr><strong>Se sim: </strong> Deixar o cliente falar e buscar esclarecer o que for preciso." +
              "<br><br><strong>Se não: </strong> Em nome de toda a QI, quero lhe dar os parabéns pela decisão e agradecer pela confiança em nossa instituição. Desejo uma ótima jornada conosco. Permaneço à disposição.",
            valid: null,
            visible: false
          }
        ]
      }
    };
  }
  getItem(itemName) {
    return this.instance[itemName];
  }
}
